export default "__VITE_ASSET__2d0IWIpB__"